/**
 * @desc 分页
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.ProductMasterResponseDto>
>;
export function request(
  params: API.basics.productMaster.postPage.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productMaster/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
